import { TrashIcon } from '@heroicons/react/24/outline';
import { ArrowDownTrayIcon, PaperClipIcon } from '@heroicons/react/24/solid';
import Button from '@/components/UI/Button';
import { HookForm } from '@/components/UI/HookForm/Form';
import { HookFileInput } from '@/components/UI/HookForm/Form/File';
import { HookFormProvider } from '@/components/UI/HookForm/Provider';
import Modal from '@/components/UI/Modal';

interface IUpdateTemplateFormProps {
  handleTemplateModal: () => void;
  data:
    | {
        name: string;
        key: string;
        contentType: string;
        size: string;
        fileUrl?: string;
      }[]
    | undefined;
  handleDeleteFile: (key: string) => void;
  handleFileUpload: (selectedFile: File[]) => void;
  isLoading: boolean;
}

const initialData = {
  template: [],
};

const UpdateTemplateForm = ({ handleTemplateModal, handleFileUpload, data, isLoading, handleDeleteFile }: IUpdateTemplateFormProps) => {
  const onSubmit = (data: any) => {
    const { template } = data;
    if (template.length) handleFileUpload(template);
  };
  return (
    <HookForm noDefaultClass className='w-full' onSubmit={onSubmit}>
      <h2 className='m-0 mb-5'>Update Template</h2>
      <div className='space-y-5'>
        <HookFileInput label='Template' name='template' id='template' multiple />
        <div className='overflow-y-auto max-h-48'>
          {data &&
            data?.length > 0 &&
            data?.map((file) => (
              <dd key={file.key} className='mt-1 p-3 flex border border-gray-200 rounded-md text-sm'>
                <div className='w-0 flex-1 flex items-center'>
                  <PaperClipIcon className='shrink-0 h-5 w-5 text-gray-400' aria-hidden='true' />
                  <span className='ml-2 flex-1 w-0 truncate'>{file.name}</span>
                </div>
                <div className='ml-4 shrink-0 flex gap-4'>
                  <a id='download-document-button' href={file.fileUrl} download>
                    <ArrowDownTrayIcon className='h-5 w-5 text-blue-600 hover:text-blue-300 cursor-pointer' />
                  </a>
                  <div id='delete-document-button' onClick={() => handleDeleteFile(file.key)}>
                    <TrashIcon className='h-5 w-5 text-red-600 hover:text-red-300 cursor-pointer' />
                  </div>
                </div>
              </dd>
            ))}
        </div>
        <div className='flex justify-end gap-4'>
          <Button label='Cancel' btnStyle='btn-neutral' type='button' onClick={handleTemplateModal} />
          <Button label={`${isLoading ? 'Creating...' : 'Add'}`} disabled={isLoading} btnStyle='btn-primary' type='submit' />
        </div>
      </div>
    </HookForm>
  );
};

const UpdateTemplateFormProvider = ({
  handleTemplateModal,
  data,
  handleDeleteFile,
  handleFileUpload,
  isLoading,
}: IUpdateTemplateFormProps) => {
  return (
    <Modal>
      <HookFormProvider defaultValues={initialData}>
        <UpdateTemplateForm
          handleFileUpload={handleFileUpload}
          handleTemplateModal={handleTemplateModal}
          data={data}
          handleDeleteFile={handleDeleteFile}
          isLoading={isLoading}
        />
      </HookFormProvider>
    </Modal>
  );
};

export default UpdateTemplateFormProvider;
